let globalConfig = null;

export function setGlobalConfig(config) {
  globalConfig = config;
}

export function getGlobalConfig() {
  return globalConfig;
}
